import { Navigate, useLocation } from 'react-router-dom';
import { useAdminSlug } from '../../contexts/PlatformConfigContext';

/**
 * Resolves the configured administration URL.
 *
 * Administration is mounted once, under `/admin`, but a deployment may put it
 * anywhere — the slug is chosen at installation and changeable afterwards.
 * This component sits on the wildcard route: if the path someone asked for is
 * the configured slug, it hands them to administration; otherwise it behaves
 * exactly as the wildcard did before.
 *
 * Two things this deliberately does NOT do:
 *   • It does not authorise anyone. Reaching administration by any URL still
 *     requires the internal staff link, authentication and the permission for
 *     whatever is being done. A private URL is obscurity, nothing more.
 *   • It does not hard-code a slug. `/admin` remains the development default
 *     only because that is what an uninstalled deployment reports.
 */
export function AdminRouteAlias() {
  const slug = useAdminSlug();
  const location = useLocation();
  const [first, ...rest] = location.pathname.replace(/^\/+/, '').split('/');
  if (first && first === slug && slug !== 'admin') {
    const remainder = rest.join('/');
    return <Navigate to={`/admin${remainder ? `/${remainder}` : ''}`} replace data-id="element-4579" data-mp="291s4ssgxtdmh" />;
  }
  return <Navigate to="/" replace data-id="element-4580" data-mp="2440eu3zus1kx" />;
}